import { render, staticRenderFns } from "./NavbarNotifications.vue?vue&type=template&id=383d6acf&scoped=true"
import script from "./NavbarNotifications.vue?vue&type=script&lang=js"
export * from "./NavbarNotifications.vue?vue&type=script&lang=js"
import style0 from "./NavbarNotifications.vue?vue&type=style&index=0&id=383d6acf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383d6acf",
  null
  
)

export default component.exports